/* eslint-disable array-callback-return */
import { useEffect, useState } from "react";
import "./MyQueries.scss";
import excel from "../../../assets/icons/excel.svg";  
import generating from "../../../assets/icons/generating.svg";
import excelWithLabel from "../../../assets/icons/excelWithLabel.svg";
import InterfaceWarning from "../../../assets/icons/InterfaceWarning.svg";
import Vector from "../../../assets/icons/Vector.svg";

import CustomButtonComponent from "../../../components/PayAnalytics/CommonComponents/CustomButtonComponent";
import { useTranslation } from "react-i18next";
import { FilterKeyValue } from "../../../constants/Filters";
import { downloadReport, getMyQueries, getQueryDetails, ReportStatus } from "services/MyQueriesServices";
import React from "react";
import Loader from "../../../components/loader";
import { formatDate } from "utilities/dateFormatter";
import ListLoader from "components/Placeholders/ListLoader";

const MyQueries = () => {
  const { t } = useTranslation();
  const reportDetails: any = {
    id: null,
    details: null,
    report: null
  };
  const [reports, setReports] = useState([]);
  const [noData, setNoData] = useState(false);
  const [listLoaded, setListLoaded] = useState(false);
  const [reportDetailLoading, setReportDetailLoading] = useState(true);
  const [currentReport, setCurrentReport] = useState(reportDetails);
  const [isBGCall, setIsBGCall] = useState(false);
  useEffect(() => {
    getReports(false);
  }, []);

  const updateStatus = (reports: any = []) => {
    if (currentReport && currentReport?.id) {
      let index = reports?.findIndex(
        (ele: any) => ele.exportReportId === currentReport?.id
      );
      if (
        index > -1 &&
        reports[index]?.reportStatus !== currentReport?.report?.reportStatus
      ) {
        let newData = {
          ...currentReport,
          report: reports[index]
        };
        setCurrentReport(newData);
      }
    }
  };

  const getReports = (isBgCall: boolean = false) => {
    getMyQueries("", isBgCall).then(
      (res: any) => {
        if (res && res?.data) {
          let reports: any =
            res?.data && res?.data[0]?.reports?.length > 0
              ? res.data[0].reports
              : [];
          setReports(reports);
          if (!reports || reports.length < 1) {
            setNoData(true);
            setReportDetailLoading(false);
          } else {
            setNoData(false);
            if (!isBgCall) {
              reportDetail(reports[0], isBgCall);
            }
            updateStatus(reports);
            refreshRequired(reports);
          }
        } else {
          setNoData(true);
          setReportDetailLoading(false);
        }
        setListLoaded(true);
      },
      (error) => {
        setNoData(true);
        setListLoaded(true);
        setReportDetailLoading(false);
        setIsBGCall(false);
      }
    );
  };
  const reportDetail = (report: any, bgCall = false) => {
    setReportDetailLoading(true);
    setCurrentReport({
      details:
        report.exportReportId !== currentReport.id
          ? null
          : currentReport.details,
      id: report.exportReportId,
      report: report
    });
    getQueryDetails(report.exportReportId, bgCall).then(
      (res: any) => {
        setIsBGCall(false);
        setReportDetailLoading(false);
        setCurrentReport({
          id: report.exportReportId,
          report: report,
          details: res.data
        });
        console.log("res.data", res.data)
      },
      (error) => {
        setReportDetailLoading(false);
      }
    );
  };

  const download = (id: any, fileName: string) => {
    downloadReport(id, fileName).then((res: any) => {});
  };

  const getFilters = (filters: any) => {
    return Object.entries(filters).map(
      ([key, value], index) => {
        return (
          value && (
            <span key={key}>
              {typeof value != "object" && (
                <div>
                  {t(FilterKeyValue[key]) as string}
                  <b> : </b>
                  {value as string}
                  {index < Object.keys(filters).length - 1 && (
                    <span>, &nbsp;</span>
                  )}
                </div>
              )}
            </span>
          )
        );
      }
      // }
    );
  };

  const getReportStatusDetails = (report: any) => {
    if (report?.reportStatus === ReportStatus.NO_DATA) {
      return (
        <div className="report-status">
          <img src={Vector} alt="Vector icon" className="excel-icon" />
          <h3 className="title">{t("pa.noData")}</h3>
          <div className="ReportExcemptionsDetailsSummary">
            {t("pa.reportDataNotFoundS1")}
            <span className="ReportExcemptionsDetails_ReportName">
              &nbsp;
              {report?.reportName}
              {report?.reportExtension
                ? "." + report?.reportExtension + "."
                : ""}
              &nbsp;
            </span>
            {t("pa.reportDataNotFoundS2")}.
          </div>
        </div>
      );
    } else if (
      report?.reportStatus === ReportStatus.FAILED ||
      report?.reportStatus === ReportStatus.EXCEL_FAILED
    ) {
      return (
        <div className="report-status">
          <div className="ReportExcemptionsDetails_NeedAttention">
            <img
              src={InterfaceWarning}
              alt="excel icon"
              className="excel-icon"
            />
            <h3 className="title">{t("pa.needAttention")}</h3>
          </div>
          <div className="ReportExcemptionsDetailsSummary">
            {t("pa.failedDescriptionS1")}
            <span className="ReportExcemptionsDetails_ReportName">
              &nbsp;
              {report?.reportName}
              {report?.reportExtension
                ? "." + report?.reportExtension + "."
                : ""}
              &nbsp;
            </span>
            {t("pa.failedDescriptionS2")}.
          </div>
          <div className="ReportExcemptionsDetails_points">
            {" "}
            <ul style={{ listStyleType: "disc" }}>
              <li>{t("pa.failedDescriptionP2")} </li>
            </ul>
          </div>
        </div>
      );
    } else if (
      report?.reportStatus === ReportStatus.SUBMITTED ||
      report?.reportStatus === ReportStatus.NOT_STARTED
    ) {
      return (
        <div className="report-status">
          <img src={generating} alt="excel icon" className="excel-icon" />
          <h3 className="title">{t("pa.generatingYourReport")}</h3>
          <p>{t("pa.generatingReportDescription")}</p>
        </div>
      );
    }
  };

  const [refreshState, setRefreshState] = useState(false);
  const [refreshCount, setRefreshCount] = useState(0);
  const refreshRequired = (data: any) => {
    let found = data.findIndex(
      (r: any) =>
        r.reportStatus === ReportStatus.SUBMITTED ||
        r?.reportStatus === ReportStatus.NOT_STARTED
    );
    setRefreshState(found > -1);
  };

  const refreshReportDetails = () => {
    if (
      currentReport?.report?.reportStatus === ReportStatus.SUBMITTED ||
      currentReport?.report?.reportStatus === ReportStatus.NOT_STARTED
    ) {
      reportDetail({ ...currentReport.report }, true);
    }
  };
  useEffect(() => {
    if (refreshCount > 0 && refreshState) {
      setIsBGCall(true);
      getReports(true);
      refreshReportDetails();
    }
  }, [refreshCount]);
  useEffect(() => {
    let interval: any;
    if (refreshState) {
      if (interval) {
        clearInterval(interval);
      }
      interval = setInterval(() => {
        setRefreshCount((prev) => prev + 1);
      }, 30000);
    } else {
      if (interval) {
        setIsBGCall(false);
        clearInterval(interval);
        setRefreshCount(0);
      }
    }

    return () => {
      if (interval) {
        clearInterval(interval);
        setRefreshCount(0);
      }
    };
  }, [refreshState]);
  return (
    <div className="pageContainer container">
      <h4 className="myquery-report-name">{t("pa.rewardBenchmarking")}</h4>
      <h2 className="title">{t("pa.myreports")}</h2>
      <div className="queriesContent">
        <div className="list-wrapper">
          <div className="list">
            {!listLoaded ? (
              // <ListLoader count={6} id={"report-list"} />tobeupdated
              <div>Loading...</div>
            ) : reports.length > 0 ? (
              reports.map((report: any, index: number) => (
                <div
                    className={`report ${
                      currentReport.id === report.exportReportId ? "active" : ""
                    }`}
                    onClick={() => {
                      reportDetail(report);
                    }}
                    key={"report-" + report.id + index}
                  >
                    <div className="indicator">
                      <img
                        src={excel}
                        alt="excel icon"
                        className="excel-icon"
                      />
                      {report.reportStatus === ReportStatus.COMPLETED && (
                        <div className="tag-name completed-tag">
                          {t("pa.ready")}
                        </div>
                      )}{" "}
                      {(report.reportStatus === ReportStatus.SUBMITTED ||
                        report.reportStatus === ReportStatus.NOT_STARTED) && (
                        <div className="submitted-tag tag-name">
                          {t("pa.generating")}
                        </div>
                      )}{" "}
                      {report.reportStatus === ReportStatus.NO_DATA && (
                        <div className="tag-name no-data-tag">
                          {t("pa.noData")}
                        </div>
                      )}{" "}
                      {(report.reportStatus === ReportStatus.FAILED ||
                        report?.reportStatus === ReportStatus.EXCEL_FAILED) && (
                        <div className="failed-tag tag-name">
                          {t("pa.failed")}
                        </div>
                      )}
                    </div>
                    <div className="report-details">
                      <div className="file-name">{report.reportName}</div>
                      {/* .{report.reportExtension} */}
                      <div className="report-date-time">
                        {t("pa.rewardBenchmarking")}
                      </div>
                      <div className="report-date-time">
                        {t("pa.created")}: {formatDate(report.createdDate)}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className={"no-data-content"}>{t("pa.noRecordsFound")}</div>
              )}
            {noData && (
              <div className={"no-data-content"}>{t("pa.noRecordsFound")}</div>
            )}
          </div>
        </div>
        <div className="details">
          {getReportStatusDetails(currentReport?.report)}
          {currentReport.report && (
            <div className="report">
              <img
                src={excelWithLabel}
                alt="excel icon"
                className="excel-icon"
              />
              <div className="report-details">
                <div className="file-name">
                  {currentReport?.report?.reportName}
                  {currentReport?.report?.reportExtension
                    ? "." + currentReport?.report.reportExtension
                    : ""}
                </div>

                {currentReport.report &&
                  (currentReport.report?.reportStatus ===
                    ReportStatus.SUBMITTED ||
                    currentReport.report?.reportStatus ===
                      ReportStatus.NOT_STARTED) && (
                    <div>
                      <div className="report-date-time">
                        {t("pa.rewardBenchmark")}
                      </div>
                      <div className="report-date-time">
                        {t("pa.created")}:{" "}
                        {formatDate(currentReport?.report?.createdDate)}
                      </div>
                    </div>
                  )}

                {currentReport.report && (
                  <div className="report-date-time">
                    <span className="static-label">{t("pa.myMarket")}: </span>
                    {currentReport?.report?.countryName}{" "}
                    <span className="divider">| </span>
                    <span className="static-label">{t("pa.currency")}: </span>
                    <span className="value">
                      {currentReport?.report?.currencyName}
                    </span>
                  </div>
                )}
                {currentReport.report &&
                  currentReport.report?.reportStatus ===
                    ReportStatus.COMPLETED && (
                    <div>
                      <div className="report-date-time">
                        {t("pa.generatedOn")}{" "}
                        {formatDate(currentReport?.report?.reportDate)}
                      </div>
                      <CustomButtonComponent
                        variant="contained"
                        text="Download Report"
                        iconPlacement="right"
                        externalClass="download-report"
                        onClick={() =>
                          download(
                            currentReport.id,
                            currentReport.report.reportName
                          )
                        }
                      />
                    </div>
                  )}
                {currentReport.report.reportStatus === ReportStatus.NO_DATA && (
                  <div className="no-data-report">
                    <b>{t("pa.noDataFound")}</b>
                  </div>
                )}
                {(currentReport.report.reportStatus === ReportStatus.FAILED ||
                  currentReport?.report?.reportStatus ===
                    ReportStatus.EXCEL_FAILED) && (
                  <div className="failed-report">
                    {t("pa.failedToGenerate")}
                  </div>
                )}
              </div>
            </div>
          )}

          {currentReport && currentReport?.details && (
            <div className="applied-filters">
              <div className="title">{t("pa.appliedFilters")}</div>
              <div className="filter-details">
                <div className="filter-name">{t("pa.customizeData")}:</div>
                <div className="filter-description">
                  {(getFilters(currentReport?.details?.configFilter || {}) as React.ReactNode)}
                </div>
              </div>
              <div className="filter-details">
                <div className="filter-name">{t("pa.filterMarket")}:</div>
                <div className="filter-description">
                  {(getFilters(currentReport?.details?.marketFilter || {}) as React.ReactNode)}
                </div>
              </div>
              {currentReport?.details?.orgFilter && Object.keys(currentReport?.details?.orgFilter)?.length > 0 && (
                <div className="filter-details">
                  <div className="filter-name">
                    {t("pa.filterOrganization")}:
                  </div>
                  <div className="filter-description">
                    {(getFilters(currentReport?.details?.orgFilter || {}) as React.ReactNode)}
                  </div>
                </div>
              )}
            </div>
          )}

          {!noData && !reportDetailLoading && !currentReport?.details && (
            <div className="applied-filters">
              <div className="title">{t("pa.appliedFilters")}</div>
              <div className="filter-details">{t("pa.noFiltersDataFound")}</div>
            </div>
          )}

          {noData && (
            <div className="no-data-content">{t("pa.noRecordsFound")}</div>
          )}
          {reportDetailLoading && !isBGCall && <Loader />}
        </div>
        {/* )} */}
      </div>
    </div>
  );
};

export default MyQueries;
